import { apiClient as apiClient } from "./client";
import type { AxiosResponse } from "axios";
import type { IUser } from "@/models/IUser";
import type { ILoginResponse, ISignUpPayload, IProfileImageResponse, UserDocumentsResponse } from "@/models/authTypes";


const baseUrl = "/auth";


export const getProfile = (): Promise<AxiosResponse<IUser>> => {
    return apiClient.get(`${baseUrl}/profile`);
};

export const register = (payload: ISignUpPayload): Promise<AxiosResponse<ILoginResponse>> => {
    return apiClient.post(`${baseUrl}/register`, payload);
};

export async function requestPasswordResetEmail(email: string): Promise<string> {
    const domain = import.meta.env.VITE_APP_AUTH0_DOMAIN;
    const clientId = import.meta.env.VITE_APP_AUTH0_CLIENT_ID;

    const response = await fetch(`https://${domain}/dbconnections/change_password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            client_id: clientId,
            email,
            connection: 'Username-Password-Authentication',
        }),
    });

    const result = await response.text();

    if (!response.ok) {
        throw new Error(`Password reset failed: ${result}`);
    }

    return result;
}


export const getProfileImage = (): Promise<AxiosResponse<IProfileImageResponse>> => {
    return apiClient.get(`${baseUrl}/profile/image`);
};

export const uploadProfileImage = (payload: { image: string; filename: string }): Promise<AxiosResponse<IProfileImageResponse>> => {
    return apiClient.post(`${baseUrl}/profile/image`, payload);
};

export const uploadPassportImages = (payload: { file: string; filename: string; type: string }): Promise<AxiosResponse<UserDocumentsResponse>> => {
    return apiClient.post(`${baseUrl}/profile/passport`, payload);
};

export const getPassportImages = (): Promise<AxiosResponse<UserDocumentsResponse>> => {
    return apiClient.get(`${baseUrl}/profile/passport`);
};

export const deletePassportImages = (uuid: string): Promise<AxiosResponse<UserDocumentsResponse>> => {
    return apiClient.delete(`${baseUrl}/profile/passport/${uuid}`);
};

export const uploadLicenseImages = (payload: { file: string; filename: string; type: string; }): Promise<AxiosResponse<UserDocumentsResponse>> => {
    return apiClient.post(`${baseUrl}/profile/license`, payload);
};

export const getLicenseImages = (): Promise<AxiosResponse<UserDocumentsResponse>> => {
    return apiClient.get(`${baseUrl}/profile/license`);
};

export const deleteLicenseImage = (uuid: string): Promise<AxiosResponse<UserDocumentsResponse>> => {
    return apiClient.delete(`${baseUrl}/profile/license/${uuid}`);
};

export const updateProfile = (payload: Partial<IUser>): Promise<AxiosResponse<IUser>> => {
    return apiClient.patch(`${baseUrl}/profile`, payload);
};

export const changePassword = (payload: { currentPassword: string; newPassword: string }): Promise<AxiosResponse<void>> => {
    return apiClient.post(`${baseUrl}/profile/change-password`, payload);
};

export const deactivateAccount = (): Promise<AxiosResponse<void>> => {
    return apiClient.delete(`${baseUrl}/profile`);
};


export const uploadVHFLicenseImages = (payload: { file: string; filename: string; type: string }): Promise<AxiosResponse<UserDocumentsResponse>> => {
    return apiClient.post(`${baseUrl}/profile/vhfLicense`, payload);
};

export const getVHFLicenseImages = (): Promise<AxiosResponse<UserDocumentsResponse>> => {
    return apiClient.get(`${baseUrl}/profile/vhfLicense`);
};

export const deleteVHFLicenseImage = (uuid: string): Promise<AxiosResponse<UserDocumentsResponse>> => {
    return apiClient.delete(`${baseUrl}/profile/vhfLicense/${uuid}`);
};
